import { render, staticRenderFns } from "./OfertarSobreDemanda.vue?vue&type=template&id=29bd2cfb&scoped=true"
import script from "./OfertarSobreDemanda.vue?vue&type=script&lang=ts"
export * from "./OfertarSobreDemanda.vue?vue&type=script&lang=ts"
import style0 from "./OfertarSobreDemanda.vue?vue&type=style&index=0&id=29bd2cfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bd2cfb",
  null
  
)

export default component.exports